module.exports = __webpack_public_path__ + "static/media/banana_tree_opt.be0a1906.gif";